import { useState } from "react";
import { Minus, Plus } from "lucide-react";

const KEY = "pgp_pro_zoom";
const STEPS = [70, 80, 90, 100, 110, 125, 140, 160];

export const usePageZoom = () => {
  const [z, setZ] = useState(() => { const v = Number(localStorage.getItem(KEY)); return STEPS.includes(v) ? v : 100; });
  const set = (v) => { setZ(v); localStorage.setItem(KEY, String(v)); };
  const i = STEPS.indexOf(z);
  return { zoom: z, inc: () => i < STEPS.length - 1 && set(STEPS[i + 1]), dec: () => i > 0 && set(STEPS[i - 1]), reset: () => set(100), min: i === 0, max: i === STEPS.length - 1 };
};

const BTN = "h-8 w-8 grid place-items-center rounded-md text-slate-700 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed";

export const ZoomControls = ({ z, className = "" }) => (
  <div className={`inline-flex items-center rounded-lg border border-slate-200 bg-white shadow-sm ${className}`} data-testid="pro-zoom-controls" role="group" aria-label="Zoom pagina">
    <button type="button" onClick={z.dec} disabled={z.min} className={BTN} title="Riduci" aria-label="Riduci zoom" data-testid="pro-zoom-out"><Minus className="h-4 w-4" /></button>
    <button type="button" onClick={z.reset} className="h-8 min-w-[3.25rem] px-1 text-xs font-semibold text-slate-700 tabular-nums hover:bg-slate-100 rounded-md" title="Ripristina 100%" data-testid="pro-zoom-value">{z.zoom}%</button>
    <button type="button" onClick={z.inc} disabled={z.max} className={BTN} title="Ingrandisci" aria-label="Aumenta zoom" data-testid="pro-zoom-in"><Plus className="h-4 w-4" /></button>
  </div>
);
